import { render, staticRenderFns } from "./UsuariosEdicao.vue?vue&type=template&id=1d07d1d6&"
import script from "./UsuariosEdicao.vue?vue&type=script&lang=ts&"
export * from "./UsuariosEdicao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports